import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

/**
 * 7HAI-2226: the ONE place react-toastify renders. Fifty-odd `toast.*` calls
 * across Bid (save, delete, config, and the Calculate card's refusal reason)
 * were no-ops because nothing ever mounted a ToastContainer — a customer PDF
 * refused with a full sentence in the 400 body produced a blank screen.
 *
 * Errors stay long enough to be read and pause while hovered; the user can
 * dismiss any toast with a click.
 */
const AppToaster: React.FC = () => (
  <ToastContainer
    position="top-right"
    autoClose={10000}
    newestOnTop
    closeOnClick
    pauseOnHover
    pauseOnFocusLoss
    draggable={false}
    limit={5}
  />
);

export default AppToaster;
